// extracted by mini-css-extract-plugin
module.exports = {"button":"_2787e5dfdf--button--1q8yR","badge":"_2787e5dfdf--badge--3P1hh"};